(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketingCampaignController', MarketingCampaignController);

    MarketingCampaignController.$inject = ['$rootScope', '$scope', '$state', 'MarketingCampaign', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'MarketingCampaignCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom', 'smsPanel'];

    function MarketingCampaignController($rootScope, $scope, $state, MarketingCampaign, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, MarketingCampaignCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom, smsPanel) {
        var vm = this;
        vm.marketingCampaign = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = false;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];
        vm.findApproveStatusStyle = findApproveStatusStyle;
        vm.smsPanel = smsPanel;
        vm.calculateSmsInfo = calculateSmsInfo;
        vm.deleteMarketingCampaign =deleteMarketingCampaign;
        vm.canEdit = true;
        vm.validateSmsPanelSendTime = validateSmsPanelSendTime;
        vm.smsPanelSendTimeWarning = null;
        vm.customerSegmentChanged = customerSegmentChanged;
        vm.openSmsPanelOverview = openSmsPanelOverview;
        vm.allCustomerSegments = [
            {
                name: 'ALL_CUSTOMERS',
                selected: false
            },
            {
                name: 'NO_RESERVATION_IN_PAST_30_DAYS',
                selected: false
            }
        ];

        initDefault();
        loadAll();

        vm.availableTimes = [
            "00:00",
            "00:30",
            "01:00",
            "01:30",
            "02:00",
            "02:30",
            "03:00",
            "03:30",
            "04:00",
            "04:30",
            "05:00",
            "05:30",
            "06:00",
            "06:30",
            "07:00",
            "07:30",
            "08:00",
            "08:30",
            "09:00",
            "09:30",
            "10:00",
            "10:30",
            "11:00",
            "11:30",
            "12:00",
            "12:30",
            "13:00",
            "13:30",
            "14:00",
            "14:30",
            "15:00",
            "15:30",
            "16:00",
            "16:30",
            "17:00",
            "17:30",
            "18:00",
            "18:30",
            "19:00",
            "19:30",
            "20:00",
            "20:30",
            "21:00",
            "21:30",
            "22:00",
            "22:30",
            "23:00",
            "23:30"
        ];


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        function initDefault() {


            if (!vm.marketingCampaign)
                vm.marketingCampaign = {};

            if (!vm.marketingCampaign.notificationTemplate)
                vm.marketingCampaign.notificationTemplate = {};

            if (!vm.marketingCampaign.type)
                vm.marketingCampaign.type = 'AUTOMATIC';

            if (!vm.marketingCampaign.status)
                vm.marketingCampaign.status = 'ACTIVE';

            if (!vm.marketingCampaign.actionType)
                vm.marketingCampaign.actionType = "AFTER_INVOICE"

            vm.marketingCampaign.notificationType = 'SMS';
            makeCustomerSegmentsSelectedOnLoad();


            if(vm.marketingCampaign.sendStatus == 'SENT' && vm.smsPanel)
                vm.canEdit = false;

            $rootScope.$broadcast('hideNavBar');

        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('customerSegment');
            // $translatePartialLoader.addPart('MarketingCampaignTypes');
            // $translatePartialLoader.addPart('MarketingCampaignPeriod');

             if(vm.marketingCampaign.fixDate) {
                    var marketingDate = new Date(vm.marketingCampaign.fixDate);
                    vm.marketingCampaign.createDate = marketingDate;
                    var hours = marketingDate.getHours();
                    var minutes = marketingDate.getMinutes();

                    // Round to the closest half-hour ("00" or "30")
                    var formattedMinutes = minutes < 30 ? "00" : "30";
                    var formattedHours = (hours < 10 ? '0' : '') + hours;

                    vm.marketingCampaign.sendTime = formattedHours + ":" + formattedMinutes;
            }


            getAllServices();
            getAllCustomerGroups();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {

            if (vm.smsPanel) {
                vm.validateSmsPanelSendTime();

                if (vm.smsPanelSendTimeWarning) {
                    vm.isSaving = false;
                    return;
                }
            }

            vm.isSaving = true;

            var datetime;

            if (vm.smsPanel) {
                if (
                    vm.marketingCampaign.sendTime &&
                    vm.marketingCampaign.createDate
                ) {
                    var timeParts = vm.marketingCampaign.sendTime.split(':');
                    var hour = parseInt(timeParts[0], 10);
                    var minute = parseInt(timeParts[1], 10);

                    var dateInstance = new Date(
                        vm.marketingCampaign.createDate
                    );

                    dateInstance.setHours(hour, minute, 0, 0);
                    datetime = dateInstance.toISOString();
                } else {
                    datetime = vm.marketingCampaign.createDate;
                }

                vm.marketingCampaign.actionType = 'SMS_PANEL';
                vm.marketingCampaign.type = 'SEMI_AUTOMATIC';
                vm.marketingCampaign.fixDate = datetime;
            }

            addServiceItems();
            addCustomerGroups();
            addCustomerSegments();

            if (vm.marketingCampaign.id) {
                MarketingCampaign.update(
                    vm.marketingCampaign,
                    onSaveSuccess,
                    onSaveError
                );
            } else {
                MarketingCampaign.save(
                    vm.marketingCampaign,
                    onSaveSuccess,
                    onSaveError
                );
            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                var currentSendTime = vm.marketingCampaign.sendTime;
                var currentCreateDate = vm.marketingCampaign.createDate;

                $scope.$emit(
                    'tikonApp:MarketingCampaignUpdate',
                    result
                );

                vm.marketingCampaign = result;

                if (vm.smsPanel) {
                    vm.marketingCampaign.sendTime = currentSendTime;
                    vm.marketingCampaign.createDate = currentCreateDate;
                }

                vm.isSaving = false;

                if (vm.smsPanel) {
                    $state.go(
                        'supplierPanel-v2.editMarketingCampaign',
                        {
                            id: result.id,
                            smsPanel: 'true'
                        }
                    );
                } else {
                    $state.go(
                        'supplierPanel-v2.editMarketingCampaign',
                        {
                            id: result.id
                        }
                    );
                }
            }
        }


        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.marketingCampaign.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.marketingCampaign.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.marketingCampaign.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.marketingCampaign.customerGroups.push(item);
                }

            })
        }
        function addCustomerSegments() {

            if (!vm.smsPanel) {
                return;
            }

            vm.marketingCampaign.customerSegments = [];

            angular.forEach(vm.allCustomerSegments, function (item) {
                if (item.selected) {
                    vm.marketingCampaign.customerSegments.push({
                        customerSegmentType: item.name
                    });
                }
            });
        }


        function makeServicesSelectedOnLoad() {


            if (vm.marketingCampaign.serviceItems && vm.marketingCampaign.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.marketingCampaign.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.marketingCampaign.customerGroups && vm.marketingCampaign.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.marketingCampaign.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

        function makeCustomerSegmentsSelectedOnLoad() {

            if (
                !vm.marketingCampaign.customerSegments ||
                vm.marketingCampaign.customerSegments.length === 0
            ) {
                return;
            }

            angular.forEach(
                vm.marketingCampaign.customerSegments,
                function (segmentDto) {

                    angular.forEach(
                        vm.allCustomerSegments,
                        function (availableSegment) {

                            if (
                                availableSegment.name ===
                                segmentDto.customerSegmentType
                            ) {
                                availableSegment.selected = true;
                            }
                        }
                    );
                }
            );
        }



        function okModal() {
            openSmsPanelOverview();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            if(smsPanel)
                $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', $rootScope.fromStateParams);
            else
                $state.go('supplierPanel-v2.marketingCampaignList', $rootScope.fromStateParams);

        }

        function getModalTitle() {
            if (vm.marketingCampaign.id){
                if(!smsPanel) return 'tikonApp.marketingCampaign.home.edit';
                return 'tikonApp.marketingCampaign.home.edit';
            }else {
                if(!smsPanel) return 'tikonApp.marketingCampaign.home.new';
                return 'tikonApp.marketingCampaign.home.newSmsPanel';
            }

        }


        function findApproveStatusStyle() {
            return "marketing-approve-status marketing-approve-status-" + vm.marketingCampaign.approveStatus;
        }

        function deleteMarketingCampaign() {
            if(smsPanel)
                $state.go('supplierPanel-v2.deleteSmsPanelMarketingCampaignFromModal', {id: vm.marketingCampaign.id});
            else  $state.go('supplierPanel-v2.deleteMarketingCampaignFromModal', {id: vm.marketingCampaign.id});
        }


        function calculateSmsInfo(text) {
            if (!text) {
                return {
                    characters: ''
                };
            }

            var length = text.length;
            var isUnicode = /[^\u0000-\u007F]/.test(text);
            var pages;

            if (isUnicode) {
                pages = length <= 70
                    ? 1
                    : Math.ceil(length / 67);
            } else {
                pages = length <= 160
                    ? 1
                    : Math.ceil(length / 153);
            }

            return {
                characters: length,
                pages: pages,
                encoding: isUnicode ? 'Unicode' : 'GSM-7'
            };
        }

        function customerSegmentChanged(changedSegment) {

            // If ALL_CUSTOMERS is checked, uncheck everything else.
            if (changedSegment.name === 'ALL_CUSTOMERS' && changedSegment.selected) {

                angular.forEach(vm.allCustomerSegments, function (segment) {
                    if (segment.name !== 'ALL_CUSTOMERS') {
                        segment.selected = false;
                    }
                });

                return;
            }

            // If any other segment is checked, uncheck ALL_CUSTOMERS.
            if (changedSegment.name !== 'ALL_CUSTOMERS' && changedSegment.selected) {

                angular.forEach(vm.allCustomerSegments, function (segment) {
                    if (segment.name === 'ALL_CUSTOMERS') {
                        segment.selected = false;
                    }
                });
            }
        }

        function validateSmsPanelSendTime() {

            vm.smsPanelSendTimeWarning = null;

            if (
                !vm.marketingCampaign.createDate ||
                !vm.marketingCampaign.sendTime
            ) {
                return;
            }

            var timeParts = vm.marketingCampaign.sendTime.split(':');
            var hour = parseInt(timeParts[0], 10);
            var minute = parseInt(timeParts[1], 10);

            var selectedDateTime =
                new Date(vm.marketingCampaign.createDate);

            selectedDateTime.setHours(hour, minute, 0, 0);

            var minimumAllowedDateTime = new Date();
            minimumAllowedDateTime.setHours(
                minimumAllowedDateTime.getHours() + 1
            );

            if (selectedDateTime < minimumAllowedDateTime) {
                vm.smsPanelSendTimeWarning =
                    'زمان ارسال باید حداقل یک ساعت بعد از زمان فعلی باشد.';
            }
        }

        $scope.$watchGroup([
            function () {
                return vm.marketingCampaign.createDate;
            },
            function () {
                return vm.marketingCampaign.sendTime;
            }
        ], function () {
            vm.validateSmsPanelSendTime();
        });


   function openSmsPanelOverview() {

       if(!vm.smsPanel)
       {
        save();
        return;
       }

       if (vm.isLoadingSmsPanelOverview) {
           return;
       }


       vm.validateSmsPanelSendTime();

       if (vm.smsPanelSendTimeWarning) {
           return;
       }

       addServiceItems();
       addCustomerGroups();
       addCustomerSegments();

       vm.isLoadingSmsPanelOverview = true;

       $mdDialog.show({
           template:
               '<md-dialog aria-label="SMS panel overview">' +
                   '<pf-sms-panel-overview ' +
                       'marketing-campaign="$ctrl.marketingCampaign" ' +
                       'on-confirm="$ctrl.confirm(overview)" ' +
                       'on-cancel="$ctrl.cancel()">' +
                   '</pf-sms-panel-overview>' +
               '</md-dialog>',

           controller: [
               '$mdDialog',
               'marketingCampaign',
               function ($mdDialog, marketingCampaign) {
                   var $ctrl = this;

                   $ctrl.marketingCampaign = marketingCampaign;

                   $ctrl.confirm = function (overview) {
                       $mdDialog.hide(overview);
                   };

                   $ctrl.cancel = function () {
                       $mdDialog.cancel();
                   };
               }
           ],

           controllerAs: '$ctrl',
           bindToController: true,

           locals: {
               marketingCampaign: angular.copy(vm.marketingCampaign)
           },

           clickOutsideToClose: true,
           escapeToClose: true
       }).then(
           function (overview) {
               vm.smsPanelOverview = overview;
               save();
           },
           function () {
               // Dialog cancelled.
           }
       ).finally(function () {
           vm.isLoadingSmsPanelOverview = false;
       });
   }
}

})();
